$(document).ready(function(){
   $(".cstm_revie-around").slick({
       slidesToShow: 4,
       slidesToScroll: 1,
       autoplay: true,
       autoplaySpeed: 3000,

       arrows: false, 
       responsive: [
          {
            breakpoint: 1299,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
               dots:true
            }
          },

          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
               dots:true
            }
          }
      ]
  });

   $(".details-ingridient-items .detail_slider").slick({
       slidesToShow: 4.3,
       slidesToScroll: 1,
       autoplay: false,
       autoplaySpeed: 2000,
       prevArrow: $(".pp2"),
       nextArrow: $(".nn2"),

       arrows: true, 
       responsive: [
          {
            breakpoint: 1299,
            settings: {
              slidesToShow: 3.3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2.3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 699,
            settings: {
              slidesToShow: 2.3,
              slidesToScroll: 1,
              dots:true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
               centerMode: true,
              dots:true
            }
          }
      ]
  });

    // checkout button click
    function checkDonationCheckout(){
      $(document).on('click', '.new_checkout[name="checkout"]', function(e){
      //$ ().click(function(e){
        e.preventDefault();
        //return false;
        // console.log('checkout-click'); 
    
        var isChecked = $('.charut_options_wrap').find('.options').find('input[type="radio"]').is(':checked');
          //$('.charut_options_wrap').find('.options').find('input[type="radio"]').prop('checked');
        var variant_id = $('.charut_options_wrap').find('.options').find('input[type="radio"]:checked').attr('data-vid');
        // console.log(variant_id);
    
        var donationPID = $('.charut_options_wrap').attr('data-pid');
        // console.log(donationPID);
    
        jQuery.getJSON('/cart.js', function(cart) {
          var items = cart.items;
          // console.log(cart.item_count);
    
          var updates = {
            updates: {}
          };
          
          if(isChecked){
           
    
            if(items.length == 1){
                console.log('items.length - 1');
                if(items[0].product_id == donationPID){
                  var data = {
                    quantity: 0,
                    id:items[0].id
                  }
                  removeDonationProduct(data);
                } else {
                  console.log('else items.length - 1');
                  updates['updates'][variant_id] = 1;
                  $.ajax({
                    url: "/cart/update.js",
                    type: "POST",
                    data: updates,
                    dataType: "json",
                    success: function (response) {
                      document.dispatchEvent(new CustomEvent("cart:refresh"));
                      location.href="/checkout";
                    },
                    error: function(error){
                    }
                  });
                }
            } else {
              console.log('else items.length > 2');
              var is_product_exist = false;
              for(var i=0; i < items.length; i++){
                if(items[i].product_id  == donationPID){
                  is_product_exist = true;
                  var data = {
                    quantity: 0,
                    id:items[i].id
                  }
                  $.ajax({
                    url: "/cart/change.js",
                    type: "POST",
                    data: data,
                    dataType: "json",
                    success: function (response) {
                      // console.log("change success");
                      //document.dispatchEvent(new CustomEvent("cart:refresh"));
    
                      // New product added.
                        updates['updates'][variant_id] = 1;
                        $.ajax({
                          url: "/cart/update.js",
                          type: "POST",
                          data: updates,
                          dataType: "json",
                          success: function (response) {
                            document.dispatchEvent(new CustomEvent("cart:refresh"));
                            setTimeout(function(){
                              location.href="/checkout";
                            },250);
                          },
                          error: function(error){
                          }
                        });
                      
                      
                    }
                  });
                }
                // if(is_product_exist == true) {
                //   break;
                // }
              }
    
              if(is_product_exist == false) {
                // console.log('is_product_exist == false');
                 updates['updates'][variant_id] = 1;
                  $.ajax({
                    url: "/cart/update.js",
                    type: "POST",
                    data: updates,
                    dataType: "json",
                    success: function (response) {
                      document.dispatchEvent(new CustomEvent("cart:refresh"));
                       location.href="/checkout";
                    },
                    error: function(error){
                    }
                  });
              }
            }
            
          } else {
            console.log('custom Else isChecked');
            location.href="/checkout";
            console.log('Else isChecked');
            // for(var i=0; i < items.length; i++){
            //   if(items[i].product_id  == donationPID){
            //     var data = {
            //       quantity: 0,
            //       id:items[i].id
            //     }
            //     removeDonationProduct(data);
            //     break;
            //   }
            // }
          }
          
        });
      
      });
    }

  checkDonationCheckout();

  $('.charut_options_wrap input[type="radio"][name="radio"]').change(function() {
    // console.log('Radio Changed');
    checkDonationCheckout();
  });

  $(document).on("click",".charut_options_wrap .options",function() {
    console.log('FN checkDonationCheckout');
    checkDonationCheckout();
  });
  
  function removeDonationProduct(data){
    console.log('removed',data);
    $.ajax({
      url: "/cart/change.js",
      type: "POST",
      data: data,
      dataType: "json",
      success: function (response) {
        // console.log("success");
        //document.dispatchEvent(new CustomEvent("cart:refresh"));
      },
      error: function(error){
        console.log("remove error");
      }
  
    });
  }

  $(function () {
  	$('.popup-modal').magnificPopup({
  		type: 'inline',
  		preloader: false,
  		focus: '#username',
  		modal: true
  	});
  	$(document).on('click', '.popup-modal-dismiss', function (e) {
  		e.preventDefault();
  		$.magnificPopup.close();
  	});
  });
  
  // $(".Click-here").on('click', function() {
  //   $(".custom-model-main").addClass('model-open');
  // }); 
  // $(".close-btn, .bg-overlay").click(function(){
  //   $(".custom-model-main").removeClass('model-open');
  // });

});                 